// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(app)/_layout/inventory/-components/screen";

export const Route = createFileRoute("/(app)/_layout/inventory/")({
    component: Component,
});
